import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/admin/roles')({
  staticData: {
    title: 'route.admin.roles',
    crumb: 'route.admin.roles',
    permissions: ['roles_view'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
